import { Component, h, State, Prop, Watch } from '@stencil/core';
import state from '@ugc-store';
import { isRtl, stringFormat, toLocalSeparator } from '@ugc-utils/utils';
import { Arrow } from 'src/icons';
import { getReviewImagesData, getReviewMoreImagesData, toSingleReviewInfo } from '@ugc-components/ugc-pdp-review/utils';
import { getReview } from '@ugc-api/review';
const SHOW_VIEW_ALL_MINIMUM_THRESHOLD = 4;

@Component({
  tag: 'ugc-review-mw-all-images',
  styleUrl: 'ugc-review-mw-all-images.scss',
  shadow: false,
})
export class UgcReviewMwAllImages {
  @Prop() productId: number;
  @State() isDataLoading = false;

  async componentWillLoad() {
    getReviewImagesData(this.productId);
  }

  @Watch('productId')
  async watchProductIdHandler() {
    getReviewImagesData(this.productId);
  }

  handleScroll = async ev => {
    if (ev.target.scrollWidth - Math.abs(ev.target.scrollLeft) - ev.target.clientWidth < 60) {
      if (!this.isDataLoading) {
        this.isDataLoading = true;
        await getReviewMoreImagesData();
        this.isDataLoading = false;
      }
    }
  };

  handleShowDetailModal = async ({ reviewId, assetId }) => {
    state.activeImageReviewId = reviewId;
    state.activeImageAssetId = assetId;
    const data = (await getReview(state.activeImageReviewId)) || {};
    state.customerImagesDetailModalData = toSingleReviewInfo(data);
    state.isShowCustomerAllImagesDetailModal = true;
  };

  render() {
    const {
      reviewStaticLanguage: { IDS_LBL_REVIEW_IMAGES = '', IDS_BTN_VIEW_ALL_IMAGES = '' },
      reviewImageListData: { items = [], totalCount = 0 },
      isShowReviewSkeleton,
      isDesktop,
    } = state;
    if (isShowReviewSkeleton) return null;
    return (
      items.length > 0 && (
        <div class="plr-16">
          <div class={`${isDesktop ? 'fs-20' : 'fs-16'} bold color-gray-700 mb-16`}>{IDS_LBL_REVIEW_IMAGES}</div>

          <div class="ugc-review-mw-all-images-wrap">
            <div class="ugc-review-images" onScroll={this.handleScroll}>
              {items.map(
                item =>
                  item.paths &&
                  item.paths.m && (
                    <div class="image-item flex">
                      <img
                        key={item.assetId}
                        src={item.paths.m}
                        alt="image"
                        class="border-1 border-solid border-gray-300 rounded-4 pointer"
                        onClick={() => this.handleShowDetailModal({ reviewId: item.reviewId, assetId: item.assetId })}
                      />
                    </div>
                  )
              )}
            </div>
          </div>
          {totalCount > SHOW_VIEW_ALL_MINIMUM_THRESHOLD && (
            <div
              class="flex-row-center-center pointer mt-8 ugc-overflow-hidden"
              onClick={() => (state.isShowCustomerImagesModal = true)}
            >
              <span class="fs-14 color-blue-dark bold">
                {stringFormat(IDS_BTN_VIEW_ALL_IMAGES, toLocalSeparator(totalCount))}
              </span>
              <span style={{ transform: isRtl() ? 'rotate(-270deg)' : 'rotate(-90deg)' }}>
                <Arrow width="24" height="24" fill="#126cc5" />
              </span>
            </div>
          )}
        </div>
      )
    );
  }
}
